import React from 'react';
import { Box } from '@mui/material';

interface TagOpsLogoProps {
  size?: number;
  variant?: 'sidebar' | 'header' | 'default';
}

export const TagOpsLogo: React.FC<TagOpsLogoProps> = ({ size = 28, variant = 'default' }) => {
  // Use different logo files based on variant
  const logoSrc = variant === 'sidebar' ? '/TagOpsLogo-512x512-transparent.png' : '/favicon.svg';
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
      }}
    >
      <img
        src={logoSrc}
        alt="TagOps"
        style={{
          height: `${size}px`,
          width: 'auto',
          display: 'block',
          verticalAlign: 'top',
        }}
      />
    </Box>
  );
};

